import React, { memo } from 'react'
import { useBreakpointContext } from 'utils/context/BreakpointContext'
import { LoadsMobileRow } from 'apps/fleet-planner/pages/loads/LoadsMobileRow'
import { LoadsTableHeader } from 'apps/fleet-planner/pages/loads/LoadsTableHeader'
import { LoadsTableRow } from 'apps/fleet-planner/pages/loads/LoadsTableRow'
import { ILoadsParams, SORT_FIELD } from 'apps/fleet-planner/types/loads'
import { Pagination, ToastState, Table, TableBody } from 'transfix-ui'

interface ILoadsTableProps {
  loadIds: string[]
  totalCount: number
  params: ILoadsParams
  onPageChange: (page: number) => void
  onSortingChange: (sortField: SORT_FIELD) => void
  setToast: (newToastState: Omit<ToastState, 'toastOpen'>) => void
}

export const LoadsTable = memo<ILoadsTableProps>(
  ({
    loadIds,
    onPageChange,
    onSortingChange,
    params: { pageNumber, pageSize, sortField, sortOrder },
    setToast,
    totalCount,
  }) => {
    const { isMobile } = useBreakpointContext()

    return (
      <>
        {isMobile ? (
          <div className='loads-table-mobile'>
            {loadIds.map(id => (
              <LoadsMobileRow key={id} loadId={id} />
            ))}
          </div>
        ) : (
          <Table>
            <LoadsTableHeader
              sortField={sortField}
              sortOrder={sortOrder}
              onSortingChange={onSortingChange}
            />
            <TableBody>
              {loadIds.map(id => (
                <LoadsTableRow setToast={setToast} key={id} loadId={id} />
              ))}
            </TableBody>
          </Table>
        )}

        {totalCount > pageSize && (
          <div className='tc'>
            <Pagination
              currentPage={pageNumber}
              numberOfPages={Math.ceil(totalCount / pageSize)}
              onPageChange={onPageChange}
            />
          </div>
        )}
      </>
    )
  }
)
